<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="10" md="4">
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">
        <v-img height="120" contain src="../../assets/Pelican_LogoB.png"></v-img>
        <!--<v-card-title v-text="card.cardTitle" class="font-weight-black justify-center"></v-card-title>-->
        <!--<v-card-subtitle v-text="card.cardSubTitle" class="font-weight-black text-center mt-0"></v-card-subtitle>-->
        <!--<center>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <b>
              <font face="微軟正黑體" size="5" color="#005a32">
                常溫單：{{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}
              </font>
            </b>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <b>
              <font face="微軟正黑體" size="5" color="#1976D2">
                低溫單：{{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}
              </font>
            </b>
          </div>
          <div v-else>
            <b>
              <font face="微軟正黑體" size="5" color="#000000">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}
              </font>
            </b>
          </div>
        </center>-->
        <br />
        <!--資料顯示方式-->
        <!--日期時間 + 貨物狀態/說明-->
        <table>
          <div v-for="n in dsmfilelst.length">
            <div v-if="n > 1">
              <div v-if="dsmfilelst[n-1].ds_id !== dsmfilelst[n-2].ds_id">
                <br /><b>
                  <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
                    <font face="微軟正黑體" size="4" color="#005a32">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                  </div>
                  <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
                    <font face="微軟正黑體" size="4" color="#1976D2">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                  </div>
                </b>
              </div>
            </div>
            <div v-else>
              <br /><b>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
                  <font face="微軟正黑體" size="4" color="#005a32">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                </div>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
                  <font face="微軟正黑體" size="4" color="#1976D2">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                </div>
              </b>
            </div>
            <br />
            <tr>
              <th width="160">{{dsmfilelst[n-1].current_time}}</th>
              <th>{{dsmfilelst[n-1].objstatus}}</th>
            </tr>
          </div>
        </table>
        <!--<div v-for="result in dsmfilelst">
          <tr>
            <th width="180">{{result.current_time}}</th>
            <th>{{result.objstatus}}</th>
          </tr><br />
        </div>-->
        <br />
        <font face="微軟正黑體" size="4" color="#FF5252">提醒您：僅限查詢近2個月內單號歷程</font><br />
        <br />
        <div v-if="btnshow===true">
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <v-btn color="success" @click="showcnee()">
              <font face="微軟正黑體" size="3">貨件資訊</font>
            </v-btn>
          </div>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <v-btn color="primary" @click="showcnee()">
              <font face="微軟正黑體" size="3">貨件資訊</font>
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div v-if="cnee===true">
            <br />
            <font face="微軟正黑體" size="4">收件人：{{this.end_name.substr(0,2)}} * </font>
          </div>
          <div v-else>
            <br />
            <font face="微軟正黑體" size="4">收件人：交寄超過30日，不顯示</font>
          </div><br />
        </div>
        <center>
          <br />
          <a href="https://www.e-can.com.tw/">
            <v-img height="80" contain src="../../assets/Pelican_IconLogo.png"></v-img>
          </a>
          <b>
            <font face="微軟正黑體" size="3" color="#555555">回官網</font>
          </b><br />
        </center>
      </v-card>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      //card: {
      //  cardTitle: "",
      //  cardSubTitle: "",
      //},
      dsmfilelst: [],
      cneelst: [],
      end_name: '',
      end_address: '',
      btnshow: true,
      cnee: true,
    };
  },
  mounted: function() {
    this.checkPage();
    this.serchDSM();
  },
  methods: {
    serchDSM: function() {
      //let url = 'https://queryapi.e-can.com.tw:9091/api/transdetail/main_id=' + this.$cookie.get('dsmid_token').substr(0, 12);
      let url = 'https://queryapi2.e-can.com.tw:9091/api/transdetail/main_id=' + this.$cookie.get('dsmid_token').substr(0, 12);
      this.$axios.get(url).then(response => {
        this.dsmfilelst = response.data.result;
      }).catch(function(error) {
        console.log(error);
      })
    },
    checkPage: function() {
      if (this.$cookie.get('page_token') != 'S') {
        this.$router.push({
          name: "ErrorPage"
        });
      } else {
        let page_token = 'O';
        this.$cookie.set('page_token', page_token, "0");
      }
    },
    showcnee: function() {
      if (this.btnshow === true) {
        this.btnshow = false;
        //let url = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_Data/' + this.$cookie.get('dsmid_token').substr(0, 15);
        let url = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_Data/' + this.$cookie.get('dsmid_token').substr(0, 15);
        this.$axios.get(url).then(response => {
          this.cneelst = response.data;
          //判斷14日內資料
          if (this.cneelst.data[0].entry_date > this.data_daysago()) {
            this.end_name = this.cneelst.data[0].end_name;
            this.end_address = this.cneelst.data[0].end_addr;
            this.cnee = true;
          } else {
            this.cnee = false;
          }
        }).catch(function(error) {
          console.log(error);
        })
      } else {
        this.btnshow = true;
      }
    },
    data_daysago() {
      let date = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // 拼接
      return year.toString() + month.toString() + day.toString();
    },

  },
};
</script>
